/**
 * Captcha provider configuration.
 * Priority:
 * 1. Russian language → Geetest
 * 2. *.GonkaGame configured domain domain → Turnstile
 * 3. Otherwise → reCAPTCHA
 */

export type CaptchaProvider = 'recaptcha' | 'turnstile' | 'geetest' | 'none'

/**
 * Determine which captcha provider to use.
 * In dev environment, captcha is disabled entirely (Geetest rejects unlisted domains).
 * Currently forced to Geetest for all production interfaces.
 */
export const getCaptchaProvider = (): CaptchaProvider => {
    if (import.meta.env.DEV) {
        return 'none'
    }
    return 'geetest'
}


/**
 * Check if current config uses Turnstile.
 */
export const isTurnstileDomain = (): boolean => getCaptchaProvider() === 'turnstile'

/**
 * Check if current config uses Geetest.
 */
export const isGeetestProvider = (): boolean => getCaptchaProvider() === 'geetest'

/**
 * Get the appropriate form field name for the captcha token.
 */
export const getCaptchaFieldName = (): string => {
    const provider = getCaptchaProvider()
    switch (provider) {
        case 'geetest':
            return 'geetest-response'
        case 'turnstile':
            return 'cf-turnstile-response'
        default:
            return 'g-recaptcha-response'
    }
}
